import { render, staticRenderFns } from "./EditSizeMenu.vue?vue&type=template&id=cbb9d368&"
import script from "./EditSizeMenu.vue?vue&type=script&lang=js&"
export * from "./EditSizeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports